export class DimensionOverridesInput {
    flangeBoltHoleDiameter: string;
    flangeHeight: string;
    flangeHubDiameter: string;
    flangeID: string;
    flangeNeckOD: string;
    flangeOD: string;
    flangePCD: string;
    flangeSocketID: string;
    flangeThickness: string;
    gasketDegrees: string;
    gasketHeight: string;
    gasketID: string;
    gasketOD: string;
    gasketPitchDiameter: string;
    gasketRingID: string;
    gasketRingOD: string;
    gasketWidth: string;
    gasketThickness: string;
    widthOfFlat: string;
    grooveDepth: string;
    outerRFOD: string;
    pitchDiameter: string;
    reducedAreaBolting: string;
    rFDepth: string;
    rFID: string;
    rFOD: string;
    rFThickness: string;
}
